import React, { useEffect, useState } from "react";
import { Card, Table, Button, Modal, Form } from "react-bootstrap";

import api from "../../../axiosConfig";
import { popup } from "../../common/popup";

const TechniciansTab = () => {
  const [technicians, setTechnicians] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const [name, setName] = useState("");

  const [editId, setEditId] = useState(null);

  const [saving, setSaving] = useState(false);

  const fetchTechnicians = async () => {
    try {
      const res = await api.get("/technicians");

      setTechnicians(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchTechnicians();
  }, []);

  const resetForm = () => {
    setName("");
    setEditId(null);
  };

  const handleClose = () => {
    setShowModal(false);
    resetForm();
  };

  const handleSave = async () => {
    if (saving) return; // cegah double submit saat jaringan lag
    if (!name) {
      popup.alert("Nama teknisi wajib diisi");
      return;
    }

    setSaving(true);
    try {
      // EDIT
      if (editId) {
        await api.put(`/technicians/${editId}`, {
          name,
        });

        popup.alert("Teknisi berhasil diupdate");
      }

      // TAMBAH
      else {
        await api.post("/technicians", {
          name,
        });

        popup.alert("Teknisi berhasil ditambahkan");
      }

      fetchTechnicians();

      handleClose();
    } catch (err) {
      console.log(err);

      popup.alert("Gagal simpan data");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);

    setName(item.name);

    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const ok = await popup.confirm("Yakin ingin menghapus teknisi ini?");

    if (!ok) return;

    try {
      await api.delete(`/technicians/${id}`);

      popup.alert("Teknisi berhasil dihapus");

      fetchTechnicians();
    } catch (err) {
      console.log(err);

      popup.alert("Gagal hapus teknisi");
    }
  };

  return (
    <>
      <Card
        style={{
          height: "calc(100vh - 85px)",
          marginTop: "-18px",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{
            background: "#fff",
            borderBottom: "1px solid #eee",
          }}
        >
          <h3 className="mb-0">Data Teknisi</h3>

          <Button
            variant="primary"
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
          >
            + Tambah Teknisi
          </Button>
        </Card.Header>

        <Card.Body
          style={{
            padding: 0,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              flex: 1,

              overflowY: "auto",
              overflowX: "auto",
            }}
          >
            <Table
              bordered
              style={{
                borderCollapse: "collapse",
                marginBottom: 0,
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#f8f9fa",
                  zIndex: 1,
                }}
              >
                <tr>
                  <th
                    width="80"
                    style={{
                      border: "1px solid #dee2e6",
                      background: "#1e3a8a",
                      color: "#fff",
                    }}
                  >
                    No
                  </th>

                  <th
                    style={{
                      border: "1px solid #dee2e6",
                      background: "#1e3a8a",
                      color: "#fff",
                    }}
                  >
                    Nama Teknisi
                  </th>

                  <th
                    width="180"
                    style={{
                      border: "1px solid #dee2e6",
                      background: "#1e3a8a",
                      color: "#fff",
                    }}
                  >
                    Aksi
                  </th>
                </tr>
              </thead>

              <tbody>
                {technicians.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="text-center">
                      Data teknisi belum ada
                    </td>
                  </tr>
                ) : (
                  technicians.map((item, index) => (
                    <tr key={item.id}>
                      <td style={{ border: "1px solid #dee2e6" }}>
                        {index + 1}
                      </td>

                      <td
                        className="cell-left"
                        style={{ border: "1px solid #dee2e6" }}
                      >
                        {item.name}
                      </td>

                      <td style={{ border: "1px solid #dee2e6" }}>
                        <div className="d-flex gap-2">
                          <Button
                            size="sm"
                            variant="warning"
                            onClick={() => handleEdit(item)}
                          >
                            Edit
                          </Button>

                          <Button
                            size="sm"
                            variant="danger"
                            onClick={() => handleDelete(item.id)}
                          >
                            Hapus
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {editId ? "Edit Teknisi" : "Tambah Teknisi"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Nama Teknisi</Form.Label>

            <Form.Control
              type="text"
              placeholder="Masukkan nama teknisi"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Batal
          </Button>

          <Button variant="primary" onClick={handleSave} disabled={saving}>
            {saving ? "Menyimpan..." : editId ? "Update" : "Simpan"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TechniciansTab;
